import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["row", "grandTotal"];

  connect() {
    this.update();
  }

  update() {
    let grandTotal = 0;
    this.rowTargets.forEach((row) => {
      const quantity = this.parse(row.querySelector("[data-invoice-total-field='quantity']"));
      const price = this.parse(row.querySelector("[data-invoice-total-field='price']"));
      const multiplier = parseFloat(row.dataset.multiplier || "1");
      const destroyed = row.querySelector("[data-invoice-total-field='destroy']")?.checked;
      const totalCell = row.querySelector("[data-invoice-total-field='total']");

      const hasValues = quantity !== null && price !== null;
      const total = hasValues ? Math.round(quantity * price * multiplier * 100) / 100 : 0;
      if (totalCell) totalCell.textContent = hasValues ? this.format(total) : "";
      if (!destroyed) grandTotal += total;
    });
    if (this.hasGrandTotalTarget) this.grandTotalTarget.textContent = this.format(grandTotal);
  }

  parse(input) {
    if (!input || input.value.trim() === "") return null;
    const value = parseFloat(input.value.replace(",", "."));
    return isNaN(value) ? null : value;
  }

  format(value) {
    return value.toFixed(2).replace(".", ",");
  }
}
